import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from '../../../../../hooks';
import { datePadStart } from '../../../../../helpers';
import { T } from '../../../../../constants';

interface PGWheelPopupTimerProps {
  date: string;
}

const initialTimer = { days: 0, hours: 0, minutes: 0, seconds: 0 };

export const PGWheelPopupTimer: React.FC<PGWheelPopupTimerProps> = ({ date }) => {

  const intervalIdRef = useRef<NodeJS.Timer | null>(null);
  const [timer, setTimer] = useState(initialTimer);

  const t = useTranslation();

  useEffect(() => {
    updateTimer();
    intervalIdRef.current = setInterval(() => updateTimer(), 900);
    return () => {
      clearTimerInterval();
    };
  }, []);

  const clearTimerInterval = useCallback(() => {
    if (intervalIdRef.current) {
      clearTimeout(intervalIdRef.current);
    }
  }, []);

  const updateTimer = useCallback(() => {
    // Get todays date and time
    const now = Date.now();
    // start and end dates by ms
    const endDateByMs = new Date(date).getTime();

    if (endDateByMs <= now) {
      setTimer({ ...initialTimer });
      clearTimerInterval();
      return;
    }

    // find the duration between now an the target date
    const duration = endDateByMs - now;
    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(duration / (1000 * 60 * 60 * 24));
    const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((duration / 1000 / 60) % 60);
    const seconds = Math.floor((duration / 1000) % 60);

    // Output the result in elements
    setTimer({ days, hours, minutes, seconds });

    if (duration / 1000 < 1) {
      clearTimerInterval();
    }

  }, [date, clearTimerInterval]);

  return (
    <div className="boosted-popup-timer-wrp">
      <div className="boosted-popup-timer-item">
        <span className="boosted-popup-timer-num">{datePadStart(timer.days)}</span>
        <p className="boosted-popup-timer-text">{t(T.DAYS_TOURNAMENT)}</p>
      </div>
      <span className="boosted-popup-timer-dots">:</span>
      <div className="boosted-popup-timer-item">
        <span className="boosted-popup-timer-num">{datePadStart(timer.hours)}</span>
        <p className="boosted-popup-timer-text">{t(T.HRS_TOURNAMENT)}</p>
      </div>
      <span className="boosted-popup-timer-dots">:</span>
      <div className="boosted-popup-timer-item">
        <span className="boosted-popup-timer-num">{datePadStart(timer.minutes)}</span>
        <p className="boosted-popup-timer-text">{t(T.MINS_TOURNAMENT)}</p>
      </div>
      <span className="boosted-popup-timer-dots">:</span>
      <div className="boosted-popup-timer-item">
        <span className="boosted-popup-timer-num">{datePadStart(timer.seconds)}</span>
        <p className="boosted-popup-timer-text">{t(T.SECS_TOURNAMENT)}</p>
      </div>
    </div>
  );
};
